import { render } from "./emploiCereales.vue?vue&type=template&id=d94493f6&scoped=true"
import script from "./emploiCereales.vue?vue&type=script&lang=js"
export * from "./emploiCereales.vue?vue&type=script&lang=js"

import "./emploiCereales.vue?vue&type=style&index=0&id=d94493f6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d94493f6"]])

export default __exports__